unit View.Pdvs.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewPdvsList = class(TForm)
    btNew: TButton;
    PdvsDataset: TXDataWebDataSet;
    PdvsDatasetid: TIntegerField;
    PdvsDatasetaliado_id: TIntegerField;
    PdvsDatasetdata_base_id: TIntegerField;
    PdvsDatasetnome: TStringField;
    PdvsDatasetnumero_caixa: TIntegerField;
    PdvsDatasetnumero_serie_nfce: TIntegerField;
    PdvsDatasetpdv_ativo: TBooleanField;
    PdvsDatasetpdv_nfce_sat: TBooleanField;
    PdvsDatasetpdv_treinamento: TBooleanField;
    PdvsDatasetbanco_dados_path: TStringField;
    PdvsDatasetbanco_dados_host: TStringField;
    PdvsDatasetcodigo_interno: TIntegerField;
    PdvsDatasetexcluido: TBooleanField;
    PdvsDatasetinclusao: TDateTimeField;
    PdvsDatasetalteracao: TDateTimeField;
    PdvsDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewPdvsList: TFViewPdvsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewPdvsList }

procedure TFViewPdvsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewPdvsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewPdvsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewPdvsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewPdvsList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewPdvsList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewPdvsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      PdvsDataset.Connection.Model.DefaultSchema.FindEntityType(PdvsDataset.EntitySetName),
      PdvsDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewPdvsList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('pdvs', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    PdvsDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewPdvsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.pdvs.list.pagination.info');
  btNew := TButton.Create('view.pdvs.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.pdvs.list.table');
  cbPageSize := TComboBox.Create('view.pdvs.list.cbPageSize');
  edSearch := TEdit.Create('view.pdvs.list.search');
  lcPaginator := TListControl.Create('view.pdvs.list.pagination');
  PdvsDataset := TXDataWebDataSet.Create(Self);
  PdvsDatasetid := TIntegerField.Create(Self);
  PdvsDatasetaliado_id := TIntegerField.Create(Self);
  PdvsDatasetdata_base_id := TIntegerField.Create(Self);
  PdvsDatasetnome := TStringField.Create(Self);
  PdvsDatasetnumero_caixa := TIntegerField.Create(Self);
  PdvsDatasetnumero_serie_nfce := TIntegerField.Create(Self);
  PdvsDatasetpdv_ativo := TBooleanField.Create(Self);
  PdvsDatasetpdv_nfce_sat := TBooleanField.Create(Self);
  PdvsDatasetpdv_treinamento := TBooleanField.Create(Self);
  PdvsDatasetbanco_dados_path := TStringField.Create(Self);
  PdvsDatasetbanco_dados_host := TStringField.Create(Self);
  PdvsDatasetcodigo_interno := TIntegerField.Create(Self);
  PdvsDatasetexcluido := TBooleanField.Create(Self);
  PdvsDatasetinclusao := TDateTimeField.Create(Self);
  PdvsDatasetalteracao := TDateTimeField.Create(Self);
  PdvsDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  PdvsDataset.BeforeLoadDFMValues;
  PdvsDatasetid.BeforeLoadDFMValues;
  PdvsDatasetaliado_id.BeforeLoadDFMValues;
  PdvsDatasetdata_base_id.BeforeLoadDFMValues;
  PdvsDatasetnome.BeforeLoadDFMValues;
  PdvsDatasetnumero_caixa.BeforeLoadDFMValues;
  PdvsDatasetnumero_serie_nfce.BeforeLoadDFMValues;
  PdvsDatasetpdv_ativo.BeforeLoadDFMValues;
  PdvsDatasetpdv_nfce_sat.BeforeLoadDFMValues;
  PdvsDatasetpdv_treinamento.BeforeLoadDFMValues;
  PdvsDatasetbanco_dados_path.BeforeLoadDFMValues;
  PdvsDatasetbanco_dados_host.BeforeLoadDFMValues;
  PdvsDatasetcodigo_interno.BeforeLoadDFMValues;
  PdvsDatasetexcluido.BeforeLoadDFMValues;
  PdvsDatasetinclusao.BeforeLoadDFMValues;
  PdvsDatasetalteracao.BeforeLoadDFMValues;
  PdvsDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewPdvsList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero_caixa';
      Title := 'numero_caixa';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero_serie_nfce';
      Title := 'numero_serie_nfce';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'pdv_ativo';
      Title := 'pdv_ativo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'pdv_nfce_sat';
      Title := 'pdv_nfce_sat';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'pdv_treinamento';
      Title := 'pdv_treinamento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'banco_dados_path';
      Title := 'banco_dados_path';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'banco_dados_host';
      Title := 'banco_dados_host';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    PdvsDataset.SetParentComponent(Self);
    PdvsDataset.Name := 'PdvsDataset';
    PdvsDataset.EntitySetName := 'Pdvs';
    PdvsDataset.Connection := DMConnection.ApiConnection;
    PdvsDataset.Left := 72;
    PdvsDataset.Top := 144;
    PdvsDatasetid.SetParentComponent(PdvsDataset);
    PdvsDatasetid.Name := 'PdvsDatasetid';
    PdvsDatasetid.FieldName := 'id';
    PdvsDatasetid.Required := True;
    PdvsDatasetaliado_id.SetParentComponent(PdvsDataset);
    PdvsDatasetaliado_id.Name := 'PdvsDatasetaliado_id';
    PdvsDatasetaliado_id.FieldName := 'aliado_id';
    PdvsDatasetaliado_id.Required := True;
    PdvsDatasetdata_base_id.SetParentComponent(PdvsDataset);
    PdvsDatasetdata_base_id.Name := 'PdvsDatasetdata_base_id';
    PdvsDatasetdata_base_id.FieldName := 'data_base_id';
    PdvsDatasetdata_base_id.Required := True;
    PdvsDatasetnome.SetParentComponent(PdvsDataset);
    PdvsDatasetnome.Name := 'PdvsDatasetnome';
    PdvsDatasetnome.FieldName := 'nome';
    PdvsDatasetnome.Size := 255;
    PdvsDatasetnumero_caixa.SetParentComponent(PdvsDataset);
    PdvsDatasetnumero_caixa.Name := 'PdvsDatasetnumero_caixa';
    PdvsDatasetnumero_caixa.FieldName := 'numero_caixa';
    PdvsDatasetnumero_serie_nfce.SetParentComponent(PdvsDataset);
    PdvsDatasetnumero_serie_nfce.Name := 'PdvsDatasetnumero_serie_nfce';
    PdvsDatasetnumero_serie_nfce.FieldName := 'numero_serie_nfce';
    PdvsDatasetpdv_ativo.SetParentComponent(PdvsDataset);
    PdvsDatasetpdv_ativo.Name := 'PdvsDatasetpdv_ativo';
    PdvsDatasetpdv_ativo.FieldName := 'pdv_ativo';
    PdvsDatasetpdv_ativo.Required := True;
    PdvsDatasetpdv_nfce_sat.SetParentComponent(PdvsDataset);
    PdvsDatasetpdv_nfce_sat.Name := 'PdvsDatasetpdv_nfce_sat';
    PdvsDatasetpdv_nfce_sat.FieldName := 'pdv_nfce_sat';
    PdvsDatasetpdv_nfce_sat.Required := True;
    PdvsDatasetpdv_treinamento.SetParentComponent(PdvsDataset);
    PdvsDatasetpdv_treinamento.Name := 'PdvsDatasetpdv_treinamento';
    PdvsDatasetpdv_treinamento.FieldName := 'pdv_treinamento';
    PdvsDatasetpdv_treinamento.Required := True;
    PdvsDatasetbanco_dados_path.SetParentComponent(PdvsDataset);
    PdvsDatasetbanco_dados_path.Name := 'PdvsDatasetbanco_dados_path';
    PdvsDatasetbanco_dados_path.FieldName := 'banco_dados_path';
    PdvsDatasetbanco_dados_path.Size := 255;
    PdvsDatasetbanco_dados_host.SetParentComponent(PdvsDataset);
    PdvsDatasetbanco_dados_host.Name := 'PdvsDatasetbanco_dados_host';
    PdvsDatasetbanco_dados_host.FieldName := 'banco_dados_host';
    PdvsDatasetbanco_dados_host.Size := 255;
    PdvsDatasetcodigo_interno.SetParentComponent(PdvsDataset);
    PdvsDatasetcodigo_interno.Name := 'PdvsDatasetcodigo_interno';
    PdvsDatasetcodigo_interno.FieldName := 'codigo_interno';
    PdvsDatasetcodigo_interno.Required := True;
    PdvsDatasetexcluido.SetParentComponent(PdvsDataset);
    PdvsDatasetexcluido.Name := 'PdvsDatasetexcluido';
    PdvsDatasetexcluido.FieldName := 'excluido';
    PdvsDatasetinclusao.SetParentComponent(PdvsDataset);
    PdvsDatasetinclusao.Name := 'PdvsDatasetinclusao';
    PdvsDatasetinclusao.FieldName := 'inclusao';
    PdvsDatasetalteracao.SetParentComponent(PdvsDataset);
    PdvsDatasetalteracao.Name := 'PdvsDatasetalteracao';
    PdvsDatasetalteracao.FieldName := 'alteracao';
    PdvsDatasetexclusao.SetParentComponent(PdvsDataset);
    PdvsDatasetexclusao.Name := 'PdvsDatasetexclusao';
    PdvsDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := PdvsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    PdvsDataset.AfterLoadDFMValues;
    PdvsDatasetid.AfterLoadDFMValues;
    PdvsDatasetaliado_id.AfterLoadDFMValues;
    PdvsDatasetdata_base_id.AfterLoadDFMValues;
    PdvsDatasetnome.AfterLoadDFMValues;
    PdvsDatasetnumero_caixa.AfterLoadDFMValues;
    PdvsDatasetnumero_serie_nfce.AfterLoadDFMValues;
    PdvsDatasetpdv_ativo.AfterLoadDFMValues;
    PdvsDatasetpdv_nfce_sat.AfterLoadDFMValues;
    PdvsDatasetpdv_treinamento.AfterLoadDFMValues;
    PdvsDatasetbanco_dados_path.AfterLoadDFMValues;
    PdvsDatasetbanco_dados_host.AfterLoadDFMValues;
    PdvsDatasetcodigo_interno.AfterLoadDFMValues;
    PdvsDatasetexcluido.AfterLoadDFMValues;
    PdvsDatasetinclusao.AfterLoadDFMValues;
    PdvsDatasetalteracao.AfterLoadDFMValues;
    PdvsDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
